"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var dx_react_grid_material_ui_1 = require("@devexpress/dx-react-grid-material-ui");
var antd_1 = require("antd");
var collectionsRef_1 = require("common/db/collectionsRef");
var usersList_1 = require("common/global/usersList");
var lodash_1 = require("lodash");
var useTitle_1 = __importDefault(require("portal/hooks/useTitle"));
var defaultDevExtremeGridComponents_1 = __importDefault(require("portal/utils/defaultDevExtremeGridComponents"));
var react_1 = __importDefault(require("react"));
var firestore_1 = require("react-firebase-hooks/firestore");
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var projectsList_1 = require("common/global/projectsList");
var moment_1 = __importDefault(require("moment"));
function AllOrders() {
    var _a;
    var t = (0, react_i18next_1.useTranslation)().t;
    var ordersSN = (0, firestore_1.useCollection)(collectionsRef_1.ordersRef)[0];
    var projectSN = (0, firestore_1.useCollection)(collectionsRef_1.projectsRef)[0];
    var IRsSN = (0, firestore_1.useCollection)(collectionsRef_1.IRsRef)[0];
    var CBAsSN = (0, firestore_1.useCollection)(collectionsRef_1.CBAsRef)[0];
    (0, useTitle_1.default)("All Orders");
    var projects = (_a = projectSN === null || projectSN === void 0 ? void 0 : projectSN.docs) === null || _a === void 0 ? void 0 : _a.filter(function (p) {
        //   return hasProjectPermission(p.id, ["ordersTabView"]);
        return true;
    }).map(function (p) { return p.id; });
    if (!IRsSN || !ordersSN || !CBAsSN || !projectSN) {
        return (0, jsx_runtime_1.jsx)(antd_1.Spin, {});
    }
    var ordersData = ordersSN.docs
        .filter(function (d) {
        //   return projects.includes(d.data()?.projectId);
        return true;
    })
        .map(function (doc, idx) {
        return __assign(__assign({}, doc.data()), { index: idx, id: doc.id });
    });
    var ordersDataSource = (0, lodash_1.sortBy)(ordersData, function (item) {
        return (0, moment_1.default)(item.createdAt).toDate();
    }).reverse();
    var ordersColumns = [
        {
            name: "projectsIds",
            title: t("projects.projectCodes"),
            getCellValue: function (r) {
                var _a;
                // const projectCode = projectSN.docs?.find(d => d.id === r.projectId)?.data()?.code ?? ''
                // return projectCode
                console.log(r.projectsIds);
                return (_a = r.projectsIds) === null || _a === void 0 ? void 0 : _a.map(function (projectId) { var _a; return (_a = projectsList_1.globalProjectsData[projectId !== null && projectId !== void 0 ? projectId : ""]) === null || _a === void 0 ? void 0 : _a.code; }).join(", ");
            },
        },
        {
            name: "ref",
            title: t("projects.irNo"),
            getCellValue: function (r) {
                var _a, _b, _c, _d;
                var IRref = (_d = (_c = (_b = (_a = IRsSN.docs) === null || _a === void 0 ? void 0 : _a.find(function (d) { return d.id === r.IRId; })) === null || _b === void 0 ? void 0 : _b.data()) === null || _c === void 0 ? void 0 : _c.ref) !== null && _d !== void 0 ? _d : "";
                return IRref;
            },
        },
        {
            name: "description",
            title: t("projects.description"),
            getCellValue: function (r) { var _a, _b, _c; return (_c = (_b = (_a = IRsSN.docs) === null || _a === void 0 ? void 0 : _a.find(function (d) { return d.id === r.IRId; })) === null || _b === void 0 ? void 0 : _b.data()) === null || _c === void 0 ? void 0 : _c.description; },
        },
        {
            name: "requestedBy",
            title: t("projects.requestedBy"),
            getCellValue: function (r) {
                var _a, _b, _c, _d, _e, _f;
                var id = (_d = (_c = (_b = (_a = IRsSN.docs) === null || _a === void 0 ? void 0 : _a.find(function (d) { return d.id === r.IRId; })) === null || _b === void 0 ? void 0 : _b.data()) === null || _c === void 0 ? void 0 : _c.requestedBy) !== null && _d !== void 0 ? _d : "";
                return (_f = (_e = usersList_1.globalUsersData[id]) === null || _e === void 0 ? void 0 : _e.name) !== null && _f !== void 0 ? _f : "";
            },
        },
        {
            name: "requestedAt",
            title: t("projects.requestedAt"),
            getCellValue: function (r) {
                var _a, _b, _c, _d;
                return (_d = (_c = (_b = (_a = IRsSN.docs) === null || _a === void 0 ? void 0 : _a.find(function (d) { return d.id === r.IRId; })) === null || _b === void 0 ? void 0 : _b.data()) === null || _c === void 0 ? void 0 : _c.requestedAt) === null || _d === void 0 ? void 0 : _d.toDate().toLocaleString();
            },
        },
        {
            name: "status",
            title: t("common.status"),
            getCellValue: function (r) {
                var _a, _b, _c, _d, _e, _f;
                var IRStatus = (_c = (_b = (_a = IRsSN.docs) === null || _a === void 0 ? void 0 : _a.find(function (d) { return d.id === r.IRId; })) === null || _b === void 0 ? void 0 : _b.data()) === null || _c === void 0 ? void 0 : _c.status;
                var CBAStatus = (_f = (_e = (_d = CBAsSN.docs) === null || _d === void 0 ? void 0 : _d.find(function (d) { return d.id === r.CBAId; })) === null || _e === void 0 ? void 0 : _e.data()) === null || _f === void 0 ? void 0 : _f.status;
                if (r.status === "preparingIR") {
                    return t("ir.".concat(IRStatus));
                }
                else if (r.status === "preparingCBA") {
                    return t("cba.".concat(CBAStatus));
                }
                else {
                    return t("orders.".concat(r.status));
                }
            },
        },
        {
            name: "completedAt",
            title: t("orders.completedAt"),
            getCellValue: function (r) {
                var _a, _b, _c, _d;
                return (_d = (_c = (_b = (_a = ordersSN.docs) === null || _a === void 0 ? void 0 : _a.find(function (d) { return d.id === r.id; })) === null || _b === void 0 ? void 0 : _b.data()) === null || _c === void 0 ? void 0 : _c.completedAt) === null || _d === void 0 ? void 0 : _d.toDate().toLocaleString();
            },
        },
        {
            name: "action",
            title: t("common.actions"),
            getCellValue: function (r) {
                return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, __assign({ to: "/orders/".concat(r.id, "/"), type: "primary", style: { margin: "0px 5px" } }, { children: t("common.details") })) }) }));
            },
        },
    ];
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)(dx_react_grid_material_ui_1.Grid, __assign({ rows: ordersDataSource, columns: ordersColumns, getRowId: function (row) { return row.id; } }, { children: __spreadArray([], (0, defaultDevExtremeGridComponents_1.default)({
                table: "orders",
            }), true) })) }));
}
exports.default = AllOrders;
